import React from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Lenis from "lenis";
import { useEffect } from "react";
import Navbar from "./components/Navbar";
import ImplantologiaStrip from "./components/ImplantologiaStrip";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import Servizi from "./pages/Servizi";
import Prezzi from "./pages/Prezzi";
import PrimaDopo from "./pages/PrimaDopo";
import Studio from "./pages/Studio";
import Contatti from "./pages/Contatti";
import { Toaster } from "./components/ui/sonner";

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }
  static getDerivedStateFromError(error) {
    return { error };
  }
  render() {
    if (this.state.error) {
      return (
        <div className="min-h-screen flex items-center justify-center bg-ivory px-6">
          <div className="text-center max-w-md">
            <p className="font-display text-3xl text-ink mb-3">Qualcosa è andato storto</p>
            <p className="text-mutedc">Ricarica la pagina o chiamaci allo 011 19667070.</p>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}

function ScrollToTop() {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (hash) {
      const t = setTimeout(() => {
        const el = document.getElementById(hash.replace("#", ""));
        if (!el) return;
        if (window.__lenis) {
          window.__lenis.scrollTo(el, { offset: -120, duration: 1.1 });
        } else {
          el.scrollIntoView({ behavior: "smooth", block: "start" });
        }
      }, 350);
      return () => clearTimeout(t);
    }
    window.scrollTo({ top: 0, left: 0, behavior: "instant" });
  }, [pathname, hash]);
  return null;
}

function SmoothScroll() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    window.__lenis = lenis;
    let raf;
    const loop = (t) => {
      lenis.raf(t);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);
  return null;
}

export default function App() {
  return (
    <ErrorBoundary>
      <BrowserRouter>
        <SmoothScroll />
        <ScrollToTop />
        <Navbar />
        <ImplantologiaStrip />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/servizi" element={<Servizi />} />
          <Route path="/prezzi" element={<Prezzi />} />
          <Route path="/prima-e-dopo" element={<PrimaDopo />} />
          <Route path="/studio" element={<Studio />} />
          <Route path="/contatti" element={<Contatti />} />
        </Routes>
        <Footer />
        <Toaster position="top-center" richColors />
      </BrowserRouter>
    </ErrorBoundary>
  );
}